/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  let lastUrl = location.href;

  function getActiveSizeFilter() {
  const activeLabel = document.querySelector(
    'label[for^="filter.v.option.size"].collection__active-filter-item'
  );

  if (activeLabel) {
    return activeLabel.textContent.replace(/\s+/g, ' ').trim();
  }

  const params = new URLSearchParams(window.location.search);

  for (const [key, value] of params.entries()) {
    if (key.toLowerCase().includes('size')) {
      return value;
    }
  }

  return null;
}

  function normalize(value) {
  return String(value)
    .toLowerCase()
    .replace(/\+/g, ' ')
    .replace(/\./g, '')
    .replace(/count/g, 'ct')
    .replace(/single[\s-]*serve/g, 'single serve')
    .replace(/\s+/g, ' ')
    .trim();
}

  function updateCardsBySizeFilter() {
    const selectedSize = getActiveSizeFilter();
    if (!selectedSize) return;

    document.querySelectorAll('.product-item').forEach(function (card) {
      const jsonEl = card.querySelector('.js-product-variants');
      if (!jsonEl) return;

      let variants;

      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      const match = variants.find(function (variant) {
        return [variant.option1, variant.option2, variant.option3].some(function (option) {
          return option && normalize(option) === normalize(selectedSize);
        });
      });

      if (!match) return;

      if (match.image) {
        const img = card.querySelector('.product-item__primary-image');

        if (img) {
          img.src = match.image;
          img.srcset = '';
        }
      }

      const priceList = card.querySelector('.product-item__price-list');

      if (priceList && match.price) {
        priceList.innerHTML = match.compare_at_price
          ? '<span class="price price--highlight"><span class="visually-hidden">Sale price</span>' +
            match.price +
            '</span><span class="price price--compare"><span class="visually-hidden">Regular price</span>' +
            match.compare_at_price +
            '</span>'
          : '<span class="price"><span class="visually-hidden">Price</span>' +
            match.price +
            '</span>';
      }
    });
  }

  function runAfterFilterUpdate() {
    updateCardsBySizeFilter();
    setTimeout(updateCardsBySizeFilter, 250);
    setTimeout(updateCardsBySizeFilter, 700);
  }

  document.addEventListener('DOMContentLoaded', runAfterFilterUpdate);
  document.addEventListener('shopify:section:load', runAfterFilterUpdate);
  window.addEventListener('popstate', runAfterFilterUpdate);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[type="checkbox"]') ||
      event.target.matches('input[type="radio"]') ||
      event.target.matches('select')
    ) {
      runAfterFilterUpdate();
    }
  });

  document.addEventListener('click', function () {
    setTimeout(function () {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        runAfterFilterUpdate();
      }
    }, 500);
  });
})();